import { render, staticRenderFns } from "./subItem.vue?vue&type=template&id=7812a0e4&scoped=true"
import script from "./subItem.vue?vue&type=script&lang=js"
export * from "./subItem.vue?vue&type=script&lang=js"
import style0 from "./subItem.vue?vue&type=style&index=0&id=7812a0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812a0e4",
  null
  
)

export default component.exports